import './custom';
import '../sass/main.scss';